import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ children, onClick }: ButtonProps) => (
  <StyledButton onClick={onClick}>
    {children}
  </StyledButton>
);
